// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qsfx3","type":"styles_type__HiLDy","choices":"styles_choices__2RCkD"};